export default {
  root: '/',
  sessionStatus: '/session-status',
  auth: {
    signup: '/signup',
    signin: '/signin',
    signout: '/signout',
    forgotPassword: '/forgot-password',
    forgotPasswordConfirm: '/forgot-password-confirm',
    forgotPasswordConfirmLegacy: '/reset-password-confirm',
    deleteAccount: '/delete-account',
    deleteAccountVerification: '/delete-account/verification',
    deleteAccountSuccess: '/delete-account-success',
    google: (env) => {
      let baseURL;
      switch (env) {
        case 'production':
          baseURL = 'https://news.spotlightnews.us';
          break;
        case 'staging':
          baseURL = 'https://news.stg.spotlightnews.us';
          break;
        case 'development':
          baseURL = 'https://news.dev.spotlightnews.us';
          break;
        default:
          break;
      }

      return `${baseURL}/users/auth/google_oauth2`;
    },
    apple: (env) => {
      let baseURL;
      switch (env) {
        case 'production':
          baseURL = 'https://news.spotlightnews.us';
          break;
        case 'staging':
          baseURL = 'https://news.stg.spotlightnews.us';
          break;
        case 'development':
          baseURL = 'https://news.dev.spotlightnews.us';
          break;
        default:
          break;
      }

      return `${baseURL}/users/auth/apple`;
    },
    github: (env) => {
      let baseURL;
      switch (env) {
        case 'production':
          baseURL = 'https://news.spotlightnews.us';
          break;
        case 'staging':
          baseURL = 'https://news.stg.spotlightnews.us';
          break;
        case 'development':
          baseURL = 'https://news.dev.spotlightnews.us';
          break;
        default:
          break;
      }

      return `${baseURL}/users/auth/github`;
    },
  },
  ambassadorLp: '/referrals/ambassador-hub',
  ambassadorLpWebViewToken: '/referrals/ambassador-hub-web-view-validate',
  ambassadorLpWebView: '/referrals/ambassador-hub-web-view',
  app: {
    getApp: '/get-app-redirect',
  },
  interest: {
    feed: (id) => `/interest/${id}`,
  },
  news: {
    main: '/news',
    feed: (id) => `/news/${id}`,
    article: (id) => `/articles/${id}`,
    sharedArticle: (id) => `/shares/articles/${id}`,
    topArticles: '/top-articles',
  },
  onboard: {
    main: '/onboard',
    interests: '/onboard/interests',
    username: '/onboard/username',
    promoCode: '/onboard/promocode',
    profileName: '/onboard/profileName',
  },
  publishers: {
    main: (slug) => `/publishers/${slug}/news`,
    topic: (slug, topicId) => `/publishers/${slug}/news/${topicId}`,
    article: (slug, articleId) => `/publishers/${slug}/articles/${articleId}`,
    about: (slug) => `/publishers/${slug}/about`,
    categories: (slug) => `/publishers/${slug}/categories`,
    recent: (slug) => `/publishers/${slug}/recent`,
    members: (slug) => `/publishers/${slug}/members`,
  },
  writers: {
    main: (slug) => `/writers/${slug}/news`,
  },
  allPublishers: '/all-publishers',
  bookmarks: '/bookmarks',
  bulkSubscriptionLp: '/lp',
  bulkSubscriptionLpClean: (landingCode = ':landingCode') => `/lp/${landingCode}`,
  bracketChallenge: (contestId) => `/bracket-challenge/${contestId}`,
  bracketLp: '/bracket',
  contestLandingPage: '/lp/contests',
  fallContestLandingPage: '/lp/fall-contest',
  halloweenLandingPage: '/lp/halloween',
  publisherLandingPage: (slug = ':slug') => `/lp/publisher/${slug}`,
  publisherLandingPageBase: '/lp/publisher',
  contests: '/contests',
  contestsWebViewToken: '/contests-web-view-validate',
  contestsWebView: '/contests-web-view',
  contestsWebViewAdRedirect: '/contests-web-view/ad/aws-october',
  contestsDetail: (contestId) => `/contests/${contestId}`,
  contestsDetailWebView: (contestId) => `/contests-web-view/${contestId}`,
  contestsPreDetail: (contestId) => `/contests/detail/${contestId}`,
  contestsPreDetailWebView: (contestId) => `/contests-web-view/detail/${contestId}`,
  discover: '/discover',
  downloadFromAppStore: 'https://itunes.apple.com/us/app/spotlight/id1291820344',
  downloadHistory: '/download-history',
  elections: '/elections',
  electionsWebViewToken: '/elections-web-view-validate',
  electionsWebView: '/elections-web-view',
  electionsInternal: (type) => `/elections/${type}`,
  electionsInternalWebView: (type) => `/elections-web-view/${type}`,
  electionsInternalDrillDown: (type, party) => `/elections/${type}/${party}`,
  electionsInternalDrillDownWebView: (type, party) => `/elections-web-view/${type}/${party}`,
  electionsLegend: '/elections/legend',
  electionsLegendWebView: '/elections/legend-web-view',
  emailConfirmation: '/email-confirmation',
  favorites: '/liked',
  licenses: 'https://spotlightnews.us/licenses',
  myLibrary: '/my-library',
  myStats: '/my-stats',
  myStatsPanel: '/my-stats-panel',
  myStatsWebViewToken: '/my-stats-web-view-validate',
  myStatsWebView: '/my-stats-web-view',
  myStatsPanelWebView: '/my-stats-panel-web-view',
  notifications: '/notifications',
  premium: '/premium',
  premiumConfirmation: '/premium-confirmation',
  premiumPurchase: (priceId) => `/premium-purchase/${priceId}`,
  profile: '/profile',
  privacyPolicy: 'https://spotlightnews.us/privacy',
  read: '/recently-read',
  referrals: '/referrals',
  referralsWebView: '/referrals-web-view',
  referralsWebViewToken: '/referrals-web-view-validate',
  terms: 'https://spotlightnews.us/terms',
  worldCupLp: '/world-cup',
  worldCup2026: '/world-cup-2026',
};
